import { useEffect, useState } from "react";

export const useCities = () => {
  const [allCities, setAllCities] = useState<{ nr: string; navn: string }[]>(
    []
  );
  const [zip, setZip] = useState("");

  useEffect(() => {
    const fetchAllCities = async () => {
      try {
        const res = await fetch(
          `https://api.dataforsyningen.dk/postnumre?landpostnumre=true`
        );
        const data = await res.json();
        setAllCities(data.sort((a: any, b: any) => a.nr.localeCompare(b.nr)));
      } catch (error) {
        console.error("Failed to fetch cities", error);
      }
    };
    fetchAllCities();
  }, []);

  const handleZipChange = (
    inputZip: string,
    selectedVendor?: any,
    handleChange?: (field: string, value: any) => void
  ) => {
    setZip(inputZip);
    const foundCity = allCities.find((c) => c.nr === inputZip);
    if (foundCity && selectedVendor && handleChange) {
      handleChange("located", foundCity.navn);
    }
  };

  return { allCities, zip, handleZipChange };
};
